/* rockkt-lead-copy-v1.js (15 Oct 2026)
 *
 * Sends a COPY of every website enquiry to Rockkt Admin > Prospecting > Leads
 * (https://app.rockkt.com/api/lead), so leads appear there automatically.
 *
 * It changes nothing about the forms themselves. The Contact, Join Rockkt and
 * Free sample pages still post to Shopify /contact exactly as before (so the
 * email to hello@ and the Google Ads conversion watcher keep working). This
 * file only watches for that post and, alongside it, sends the same details to
 * the app. If the copy fails for any reason, the visitor never knows and the
 * Shopify email is still sent.
 *
 * Skipped: newsletter sign-ups (not leads), and anything the page's own
 * honeypot stopped (the page never calls /contact in that case).
 */
(function () {
  if (window.__rkLeadCopyV1) return;
  window.__rkLeadCopyV1 = true;
  var API = 'https://app.rockkt.com/api/lead';
  var orig = window.fetch;
  if (typeof orig !== 'function') return;

  function dec(s) { try { return decodeURIComponent(String(s).replace(/\+/g, ' ')); } catch (e) { return String(s); } }

  function contactFields(body) {
    var out = {};
    String(body).split('&').forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i < 0) return;
      var m = /^contact\[(.*)\]$/.exec(dec(pair.slice(0, i)));
      if (m) out[m[1]] = dec(pair.slice(i + 1));
    });
    return out;
  }

  function attribution() {
    var a = {};
    try {
      var q = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'].forEach(function (k) {
        var v = q.get(k); if (v) a[k] = v;
      });
    } catch (e) { /* older browsers: no attribution, still a lead */ }
    return a;
  }

  function formName(type) {
    var t = String(type || '').toLowerCase();
    if (t.indexOf('free sample') >= 0) return 'free-sample';
    if (t.indexOf('join') >= 0) return 'join';
    return 'contact';
  }

  function buildLead(c) {
    var type = c['Request type'] || '';
    var name = c.name || [c['First name'], c['Last name']].filter(Boolean).join(' ');
    var extra = [];
    if (type) extra.push('Request type: ' + type);
    if (c['Team size']) extra.push('Team size: ' + c['Team size']);
    var p = {
      name: name, email: c.email || '', company: c.Company || '', phone: c.Mobile || '',
      message: [c.body || ''].concat(extra).filter(Boolean).join('\n'),
      form_name: formName(type), page_url: String(window.location.href).split('#')[0],
      submission_id: 'web-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10)
    };
    if (c['Address line 1'] || c.Postcode) {
      p.sample_name = name;
      p.sample_addr1 = c['Address line 1'] || '';
      p.sample_addr2 = c['Address line 2'] || '';
      p.sample_city = c['Town or city'] || '';
      p.sample_postcode = c.Postcode || '';
      p.sample_country = c.Country || 'United Kingdom';
      p.sample_country_code = (c.Country || 'United Kingdom') === 'United Kingdom' ? 'GB' : '';
    }
    var a = attribution();
    for (var k in a) p[k] = a[k];
    return p;
  }

  function send(p) {
    var parts = [];
    for (var k in p) if (p[k]) parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(p[k]));
    // A plain form post: no CORS preflight, survives the page changing (keepalive),
    // and redirect:'manual' stops the browser following the app's 303 back to the site.
    return orig.call(window, API, {
      method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true, redirect: 'manual',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: parts.join('&')
    });
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = String((init && init.method) || 'GET').toUpperCase();
      var body = init && typeof init.body === 'string' ? init.body : '';
      if (method === 'POST' && /^(https?:\/\/(www\.)?rockkt\.com)?\/contact(\?|$)/.test(url) && body.indexOf('contact[') >= 0) {
        var c = contactFields(body);
        if (!/newsletter/i.test(c['Request type'] || '') && (c.email || c.name || c['First name'])) {
          send(buildLead(c)).catch(function () { /* the Shopify email still goes */ });
        }
      }
    } catch (e) { /* never get in the way of the real form */ }
    return orig.apply(this, arguments);
  };
})();
